import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.06 2.49a2 2 0 0 0-2 2v1.36a4.033 4.033 0 0 1 2.782-.283c2.263.595 3.551 3.077 2.877 5.544-.673 2.467-2.927 4.975-5.561 4.283A3.414 3.414 0 0 1 8 14.846a3.414 3.414 0 0 1-1.158.548c-2.634.692-4.888-1.816-5.562-4.283-.673-2.467.615-4.95 2.878-5.544.997-.262 2.016-.115 2.903.344V4.49c0-.182.012-.362.035-.537-.743.432-1.818.41-2.764-.137-1.093-.631-1.666-1.76-1.46-2.719C3.6.437 4.865.37 5.958 1.001c.777.448 1.29 1.148 1.45 1.86A4 4 0 0 1 11.06.49v2Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconComfortFruit16 = createIcon(IconComponent);